// YouTube BrandConnect Notice - displays the YouTube campaign code so the
// creator can link a video to the brand's BC campaign.

import { ExternalLink, Info } from "lucide-react";

interface YouTubeBrandConnectNoticeProps {
  campaignCode: string;
}

export function YouTubeBrandConnectNotice({
  campaignCode,
}: YouTubeBrandConnectNoticeProps) {
  return (
    <div className="flex gap-3 p-3 rounded-lg bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800">
      <Info className="h-4 w-4 mt-0.5 shrink-0 text-blue-600 dark:text-blue-400" />
      <div className="text-sm text-blue-800 dark:text-blue-200">
        <strong className="block mb-1">Link Video To YouTube Campaign</strong>
        <p className="mb-2">Content must be linked to a YouTube Campaign.</p>
        <p className="mb-2">
          Use the campaign code{" "}
          <code className="px-1.5 py-0.5 rounded bg-blue-100 dark:bg-blue-900/60 font-mono text-xs select-all">
            {campaignCode}
          </code>{" "}
          to link a new or existing video to the YouTube campaign and share
          brand partner access.
        </p>
        <a
          href="https://help.aspireiq.com/en/articles/14789829-sharing-brand-partner-access-to-youtube-videos"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-xs inline-flex items-center gap-1"
        >
          Learn more
          <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </div>
  );
}
